import React from 'react';
import PropTypes from 'prop-types';

function UncheckIcon({
  color, containerColor, label, onClick, size,
}) {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <circle cx="12" cy="12" r="11.5" fill={containerColor} stroke={color} />
    </svg>
  );
}

UncheckIcon.propTypes = {
  color: PropTypes.string,
  containerColor: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
};

UncheckIcon.defaultProps = {
  color: 'var(--k-ds-color-grey-500)',
  containerColor: 'var(--k-ds-color-grey-300)',
  label: 'No Seleccionado',
  onClick: () => { },
  size: 24,
};

export default UncheckIcon;
